export default function AddToWatchlistCookie(identifier) {
  $.cookie('addToWatchlistAfterLogin', identifier, { expires: 365, path: '/' });
}